import { useMemo } from 'react';

export default function useIsIframe() {
  return useMemo(() => {
    try {
      return window.self !== window.top;
    } catch (error) {
      return true;
    }
  }, []);
}
